import { licenseTypeRequest } from '@/common/queries/selections/licenseTypeRequest';
import { useQuery } from '@tanstack/react-query';

export const useLicenseTypeRequest = () => {
  const licenseTypeQuery = useQuery({
    queryKey: ['licenseType'],
    queryFn: () => licenseTypeRequest(),
    select: (data) => {
      return data?.map((item) => ({
        label: item?.license_type.fa_const,
        value: item?.id,
      }));
    },
  });
  return { licenseTypeQuery };
};
